export enum StepName {
  PropertyAndLoan,
  Applicants,
  IncomeAndExpenditure,
  Results,
  MortgageRequirements,
}
